import React from "react";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from "react-select-new";

export default class ReportTrainerCourses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            trainer: "",
            has_qualitymark: false,
            dataTrainers: [],
            notice: "",
            success: "",
            period1Disabled: false
        };
    }

    updateElementState = (e) => {
        if (e.target.type === "checkbox") {
            this.setState({
                [e.target.name]: e.target.checked,
                trainer: "",
                period1Disabled: false
            });
            this.getData(e.target.checked);
        } else {
            this.setState({
                [e.target.name]: e.target.value,
                period1Disabled: false
            });
        }
    };

    handleDateChange = (name, date) => {
        this.setState({
            [name]: date,
            period1Disabled: false,
            notice: "",
            success: ""
        });
    };

    downloadReport = (type) => {
        let notice = "";
        let success = "";
        switch (type) {
            case "1period":
                if (this.state.startDate && this.state.endDate && this.state.trainer !== "") {
                    let url =
                        "/v1/reports/trainer-courses/" +
                        `?period1_after=${moment(this.state.startDate).format("YYYY-MM-DD")}` +
                        `&period1_before=${moment(this.state.endDate).format("YYYY-MM-DD")}` +
                        `&trainer=${this.state.trainer.uuid}`;
                    axios
                        .get(url)
                        .then((response) => {
                            let message = "Het rapport wordt gegenereerd en per e-mail naar je verzonden.";
                            if (response.data && response.data.message) {
                                message = response.data.message;
                            }

                            this.setState({
                                period1Disabled: true,
                                success: message
                            });
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    notice = "Zowel begindatum, einddatum en opleider is vereist voor periode 1";
                }
                break;
            default:
                throw new Error("No such report type: " + type);
        }
        this.setState({
            notice,
            success
        });
    };

    componentDidMount = () => {
        this.getData();
    };

    getData = (has_qualitymark = this.state.has_qualitymark) => {
        let url = "/v1/trainers/?fields=uuid,name&pagination=false&is_active=1";
        if (has_qualitymark) {
            url += "&has_qualitymark=1";
        }
        axios
            .get(url)
            .then((response) => {
                this.setState({
                    dataTrainers: response.data
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    render() {
        let notice = "";
        if (this.state.notice !== "") {
            notice = <div className="alert alert-warning">{this.state.notice}</div>;
        }
        let success = "";
        if (this.state.success !== "") {
            success = <div className="alert alert-success">{this.state.success}</div>;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <h2>Opleiderrapportage (uitgebreid)</h2>
                        {notice}
                        {success}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-8">
                        <h3>Opleider</h3>
                        <Select
                            className="react-select-new"
                            classNamePrefix="react-select"
                            name="trainer"
                            onChange={(trainer) =>
                                this.setState({
                                    trainer,
                                    period1Disabled: false
                                })
                            }
                            value={this.state.trainer}
                            options={this.state.dataTrainers}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.uuid}
                            controlShouldRenderValue={true}
                            isClearable={false}
                            placeholder="Selecteer een opleider"
                            noOptionsMessage={() => "Geen opleiders gevonden"}
                        />
                        <div className="custom-control custom-checkbox" style={{ position: "static" }}>
                            <input
                                type="checkbox"
                                name="has_qualitymark"
                                className="custom-control-input"
                                id="only_qualitymark_trainers2"
                                onChange={this.updateElementState}
                                checked={this.state.has_qualitymark}
                            />
                            <label className="custom-control-label" htmlFor="only_qualitymark_trainers2">
                                Toon alleen keurmerk opleiders
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-4">
                        <DatePicker
                            name="startDate"
                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                            onChange={(value) => this.handleDateChange("startDate", value)}
                            onChangeRaw={(event) => {
                                let value = event.target.value.split("-").join("");
                                let newDate = value.substring(0, 2);
                                if (value.length >= 3) {
                                    newDate += "-" + value.substring(2, 4);
                                }
                                if (value.length >= 5) {
                                    let checkYear = value.substring(4, 8);
                                    if (checkYear.length == 2 && checkYear != "19" && checkYear != "20") {
                                        newDate += "-19" + value.substring(4, 8);
                                    } else {
                                        newDate += "-" + value.substring(4, 8);
                                    }
                                }
                                event.target.value = newDate;
                            }}
                            className="form-control"
                            required={false}
                            placeholderText="Datum vanaf (dd-mm-yyyy)"
                            selected={this.state.startDate}
                            autoComplete="off"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>
                    <div className="col-4">
                        <DatePicker
                            name="endDate"
                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                            onChange={(value) => this.handleDateChange("endDate", value)}
                            onChangeRaw={(event) => {
                                let value = event.target.value.split("-").join("");
                                let newDate = value.substring(0, 2);
                                if (value.length >= 3) {
                                    newDate += "-" + value.substring(2, 4);
                                }
                                if (value.length >= 5) {
                                    let checkYear = value.substring(4, 8);
                                    if (checkYear.length == 2 && checkYear != "19" && checkYear != "20") {
                                        newDate += "-19" + value.substring(4, 8);
                                    } else {
                                        newDate += "-" + value.substring(4, 8);
                                    }
                                }
                                event.target.value = newDate;
                            }}
                            className="form-control"
                            required={false}
                            placeholderText="Datum tot en met (dd-mm-yyyy)"
                            selected={this.state.endDate}
                            autoComplete="off"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>
                    <div className="col-4">
                        <button className="btn btn-secondary" onClick={(e) => this.downloadReport("1period")}>
                            Genereer rapport
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
